exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#preview-page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; }\n  #preview-page .button-bar {\n    display: flex; }\n  #preview-page .row-count {\n    flex: 1 1 auto;\n    background: black;\n    color: #777;\n    text-align: center;\n    padding: 0.25rem; }\n", ""]);

// exports
